import { EpimsBaseEntityDto } from './epim-base.dto';

export class ImpactedCommunityDto extends EpimsBaseEntityDto{
    
    SerialId: string;
    ImpactedStateId: string;
    ImpactedLGAId: string;
    ImpactedCommunityName: string;
    Remarks:string;
    IncidentNotificationId:string;
    ImpactedState:string;
    ImpactedLGA: string;
    ImpactedCommunityId:string;
    CreatedPersonId: string;
    CreatedDate: Date;
}